import { motion } from "framer-motion";
import { FileDown, ArrowUpRight } from "lucide-react";
import { CATALOGS } from "../../data/site";

export const Catalogs = () => (
    <section id="catalogs" data-testid="catalogs-section" className="bg-navy py-24 lg:py-32 relative overflow-hidden">
        <div className="absolute inset-0 blueprint-grid" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                className="mb-14"
            >
                <p className="font-mono text-[11px] tracking-[0.35em] text-gold mb-6" data-testid="catalogs-overline">
                    05 / DOWNLOAD CATALOGS
                </p>
                <h2 className="font-heading font-extrabold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="catalogs-heading">
                    TAKE THE FACTORY<br />
                    <span className="text-outline-light">WITH YOU.</span>
                </h2>
                <p className="mt-6 max-w-xl text-slate-400 text-base md:text-lg leading-relaxed">
                    Product catalogs with models, finishes and frame options — share them with your
                    procurement team or architect.
                </p>
            </motion.div>

            <div className="space-y-12" data-testid="catalogs-grid">
                {["Seating", "Dining & Café", "Sofas & Lounge"].map((group) => (
                    <div key={group}>
                        <p className="font-mono text-[11px] tracking-[0.3em] text-gold mb-5" data-testid={`catalog-group-${group.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                            {group.toUpperCase()}
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {CATALOGS.filter((c) => c.category === group).map((cat) => (
                                <motion.a
                                    key={cat.title}
                                    href={cat.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    initial={{ opacity: 0, y: 32 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-40px" }}
                                    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                                    className="group border border-white/15 bg-white/5 hover:bg-white/10 hover:border-gold transition-colors duration-300 p-8 flex items-center gap-6"
                                    data-testid={`catalog-card-${cat.title.toLowerCase().replace(/\s+/g, "-")}`}
                                >
                                    <span className="w-14 h-14 shrink-0 bg-gold flex items-center justify-center">
                                        <FileDown size={22} className="text-navy" />
                                    </span>
                                    <span className="flex-1">
                                        <span className="block font-heading font-bold tracking-tight text-white text-xl">{cat.title}</span>
                                        <span className="block mt-1 font-mono text-[11px] tracking-[0.2em] text-slate-400 uppercase">{cat.meta}</span>
                                    </span>
                                    <ArrowUpRight size={20} className="text-gold shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                                </motion.a>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <p className="mt-8 font-mono text-[11px] tracking-[0.2em] text-slate-500" data-testid="catalogs-note">
                MORE CATALOGS COMING SOON — WORKSTATIONS · DESKS · STORAGE
            </p>
        </div>
    </section>
);
